<app-nav></app-nav>

<div class="page">

  <!-- Live shuru karne se pehle -->
  <div class="card start-card" *ngIf="!isLive">
    <div class="icon-circle">📡</div>
    <h2 style="color: #c4b5d0;">Go Live</h2>
    <p class="sub">Turn on your camera and mic and go live, or stream from OBS Studio. Anyone with the link can watch.</p>

    <div class="start-actions">
      <button class="btn btn-primary btn-lg" (click)="goLiveClicked()" [disabled]="starting">
        {{ starting ? 'Starting…' : '🔴 Go Live (Camera)' }}
      </button>
      <button class="btn btn-outline btn-lg" (click)="goLiveRtmpClicked()" [disabled]="starting">
        🎥 Stream with OBS
      </button>
    </div>

    <p class="error" *ngIf="error">{{ error }}</p>
  </div>

  <!-- Live chalte waqt -->
  <div class="card live-card" [hidden]="!isLive">
    <div class="live-top">
      <span class="live-badge" *ngIf="!isRtmp || rtmpConnected"><i class="dot"></i> LIVE</span>
      <span class="live-badge wait" *ngIf="isRtmp && !rtmpConnected">Waiting for OBS…</span>
      <span class="viewers">👁 {{ viewers }} watching</span>
    </div>

    <div class="video-frame">
      <video #localVideo [hidden]="isRtmp" autoplay muted playsinline></video>
      <video #rtmpVideo class="no-mirror" [hidden]="!isRtmp" autoplay muted playsinline></video>
    </div>

    <!-- OBS settings -->
    <div class="rtmp-box" *ngIf="isRtmp">
      <h4>OBS settings</h4>
      <p class="rtmp-help">
        OBS &rarr; Settings &rarr; Stream &rarr; Service: <b>Custom…</b>, paste the Server and Stream Key below, then press <b>Start Streaming</b>.
        To end the live, press <b>Stop Streaming</b> in OBS.
      </p>

      <label>Server</label>
      <div class="rtmp-row">
        <input type="text" [value]="rtmpUrl" readonly />
        <button type="button" class="btn btn-outline" (click)="copyText(rtmpUrl, 'Server URL')">Copy</button>
      </div>

      <label>Stream Key <small>(keep it private)</small></label>
      <div class="rtmp-row">
        <input [type]="showKey ? 'text' : 'password'" [value]="rtmpKey" readonly />
        <button type="button" class="btn btn-outline" (click)="showKey = !showKey">{{ showKey ? 'Hide' : 'Show' }}</button>
        <button type="button" class="btn btn-outline" (click)="copyText(rtmpKey, 'Stream key')">Copy</button>
      </div>

      <p class="rtmp-status" [class.ok]="rtmpConnected">
        {{ rtmpConnected ? '✅ OBS connected — you are live.' : '⏳ Start streaming in OBS, this turns green when it connects.' }}
      </p>
    </div>

    <div class="share-row" *ngIf="streamToken">
      <button *ngIf="canShare" class="btn btn-primary" (click)="shareLive()">Share</button>

      <ng-container *ngIf="!canShare">
        <a class="btn btn-whatsapp" [href]="whatsappLink" target="_blank" rel="noopener">WhatsApp</a>
        <a class="btn btn-facebook" [href]="facebookLink" target="_blank" rel="noopener">Facebook</a>
      </ng-container>

      <button class="btn btn-outline" (click)="copyViewerLink()">Copy Link</button>
    </div>

    <!-- Live Chat page ke members ki chat yahan dikhti hai -->
    <div class="chat-box">
      <h4>Live chat</h4>
      <div class="chat-msgs" #chatBox>
        <p class="chat-empty" *ngIf="!chat.length">Messages from viewers on the Live Chat page will appear here.</p>
        <div class="chat-msg" *ngFor="let m of chat" [class.mine]="m.mine">
          <b>{{ m.mine ? 'You' : m.name }}</b>
          <span>{{ m.text }}</span>
        </div>
      </div>
      <div class="chat-row">
        <input [(ngModel)]="newMsg" (keyup.enter)="sendChat()" placeholder="Type a message..." maxlength="300" autocomplete="off" />
        <button type="button" class="btn btn-primary" (click)="sendChat()" [disabled]="!newMsg.trim()">Send</button>
      </div>
    </div>

    <button class="btn btn-danger btn-block" (click)="stopLive()">{{ isRtmp ? 'Close this panel' : 'Stop Live' }}</button>
  </div>

</div>